module.exports = __webpack_public_path__ + "img/avatar_36.132983e6.svg";